import * as _ from 'lodash';
import * as Mutations from '@/store/modules/users/mutations';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export const ActivityInstructorFormMixin = {
    computed: {
        ...mapGetters(['instructors'])
    },
    watch: {
        instructors(newValue, oldValue) {
            this.selectedLastAddedElement(newValue, oldValue, this.setInstructorId);
        }
    },
    methods: {
        ...mapActions(['openModal', 'getInstructors']),

        ...mapMutations({
            setInstructors: Mutations.SET_INSTRUCTORS,
        }),
        async openInstructorModal() {
            await this.$nextTick();
            this.openModal({
                modalName: 'InstructorModal',
                callback: ({ submitted }) => submitted && this.getInstructors(),
            });
        },
        lastAddedElement(arr1, arr2) {
            if (!arr1 || !arr2) return;
            const [newElement] = _.differenceBy(arr1, arr2, 'id');
            return newElement;
        },
        selectedLastAddedElement(arr1, arr2, callback) {
            const newElement = this.lastAddedElement(arr1, arr2);
            newElement && callback(newElement);
        },
        formatInstructor: el => el.firstName + ' ' + el.lastName,
    },
    created() {
        this.setInstructors(null);
        this.getInstructors();
    }
};


// WEBPACK FOOTER //
// ./src/mixins/ActivityInstructorFormMixin.js